
jQuery(function(){
    var ua = navigator.userAgent;
    if((ua.indexOf('iPhone') > 0) || ua.indexOf('iPod') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)){
        $('head').prepend('<meta name="viewport" content="width=device-width,initial-scale=1">');
    } else {
        $('head').prepend('<meta name="viewport" content="width=1024">');
    }
});


jQuery(function () {
    if (window.matchMedia('(max-width: 1140px)').matches) {
        jQuery('#toggle').click(function(){//bodyに .openNav を付加・削除
            jQuery('body').toggleClass('navi_open');
        });
        jQuery('.menu-item a').click(function(){//bodyに .openNav を付加・削除
            if($('body').hasClass('navi_open')){ // クリックされた要素がclickedクラスだったら
                $('body').removeClass('navi_open');
            }else{
                $(this).addClass('navi_open');
            }
            jQuery('body').removeClass('navi_open');
        });
        // 親メニュー処理
        jQuery('.menu-item-has-children').click(function() {
            jQuery(this).toggleClass('menu_open');
            // メニュー表示/非表示
            jQuery(this).next('.sub-menu').slideToggle();
        });
        // 子メニュー処理
        jQuery('.menu-item-has-children').click(function(e) {
            // メニュー表示/非表示
            jQuery(this).children('.sub-menu').slideToggle();
            e.stopPropagation();
        });
    }
});

//////購入ボタン
$(function () {
    if (window.matchMedia('(max-width: 767px)').matches) {
      $('.buy_btn li p').click(function () {
        if($(this).next().hasClass("lp_tmask_show")){
            $(this).next().slideUp();
            $(this).next().removeClass("lp_tmask_show");
            $(this).removeClass("lp_tmask_show");
        }else{
            $(this).next().slideDown();
            $(this).next().addClass("lp_tmask_show");
            $(this).addClass("lp_tmask_show");
        }
      });
    } else {
      $('.buy_btn li').hover(function () {
        $("ul:not(:animated)", this).slideDown();
      }, function () {
        $("ul.buy_item_btn_area", this).slideUp();
      });
    }
});


// フローティング スクロール途中でfixed
/* エレメント丸ごとコメントアウトしてあってエラー出るのでここもコメント
jQuery(function() {
  $(window).on('load resize', function() {
    var floatBtn = $('.floatBtn');
    var isAnimate = 'fixed';
    var elemOffset = floatBtn.offset().top;
    var elemHeight = floatBtn.outerHeight();
    var wh = $(window).height();
    $('.floatBtn').fadeIn();
    if(wh > elemOffset + elemHeight){
      floatBtn.addClass(isAnimate);
    }else{
      floatBtn.removeClass(isAnimate);
      $(window).on("scroll", function() {
        var scroll = $(this).scrollTop();
        if (scroll > elemOffset + elemHeight - wh) {
            floatBtn.addClass(isAnimate);
            floatBtn.fadeIn(400);
        } else {
            floatBtn.removeClass(isAnimate);
        }
      });
    }
  });
});
*/



//フローティング ボタンクリックでフェードアウト
jQuery(function() {
  jQuery('.floatBtn_close').click(function(){
		jQuery('.floatBtn').fadeOut(0);
	});
});


//payment画像表示
jQuery(function() {
  var $hover_btn = $('#navGlobal .buy_btn_wrap');
  $hover_btn.hover(
    function() {
      //マウスカーソルが重なった時の処理
      $(this).children('.payment').fadeIn();
    },
    function() {
        //マウスカーソルが離れた時の処理
        $(this).children('.payment').fadeOut();
    }
  );
});


//js-scroll(1s)
var EffectH = 50;
jQuery(window).on('scroll load', function() {
  var scTop = $(this).scrollTop();
  var scBottom = scTop + $(this).height();
  var effectPos = scBottom - EffectH;
  jQuery('.js-scroll').each( function() {
    var thisPos = $(this).offset().top;
    if ( thisPos < effectPos ) {
      $.when(
        jQuery(this).addClass("lp_tmask_show")
      ).done(function() {
        jQuery(this).delay(250).queue(function(){
            jQuery(this).addClass("done")
        })
      });
    }
  });
  jQuery('.js-scroll-500').each( function() {
    var thisPos = $(this).offset().top;
    if ( thisPos < effectPos ) {
      $.when(
        jQuery(this).addClass("lp_tmask_show")
      ).done(function() {
        jQuery(this).delay(500).queue(function(){
            jQuery(this).addClass("done")
        })
      });
    }
  });
  jQuery('.js-scroll-750').each( function() {
    var thisPos = $(this).offset().top;
    if ( thisPos < effectPos ) {
      $.when(
        jQuery(this).addClass("lp_tmask_show")
      ).done(function() {
        jQuery(this).delay(750).queue(function(){
            jQuery(this).addClass("done")
        })
      });
    }
  });
  jQuery('.js-scroll-1000').each( function() {
    var thisPos = $(this).offset().top;
    if ( thisPos < effectPos ) {
      $.when(
        jQuery(this).addClass("lp_tmask_show")
      ).done(function() {
        jQuery(this).delay(1000).queue(function(){
            jQuery(this).addClass("done")
        })
      });
    }
  });
});


// スムーズスクロール
jQuery(function(){
    // ページ内リンクをクリックすると
    jQuery('a[href^="#"]').click(function(){
      console.log("aaa");
        // スクロールスピード
        var speed = 500;
        // ヘッダー等の高さ分の数値を入れる
        var headerHight = $('.global_header_inner').outerHeight();
        if(!headerHight) headerHight = 0;
        // クリックしたリンク先を保存
        var href= jQuery(this).attr("href");
        // クリックしたリンク先が#または空のときは
        var target = jQuery(href == "#" || href == "" ? 'html' : href);
        // トップへ移動する
        var position = target.offset().top-headerHight;
        // リンク先へスムーズに移動する
        jQuery("html, body").animate({scrollTop:position}, speed, "swing");
        return false;
    });
});

// page Topフェードイン・アウト
jQuery(function($){
  $(window).bind("scroll", function() {
      if ($(this).scrollTop() > 600) { 
          $(".pageTop").fadeIn(500);
      } else {
          $(".pageTop").fadeOut(500);
      }
  });
});




// スマホtel link
if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/)) {
    $(function() {
        $('.tel').each(function() {
            var str = $(this).html();
            if ($(this).children().is('img')) {
                $(this).html($('<a>').attr('href', 'tel:' + $(this).children().attr('alt').replace(/-/g, '')).append(str + '</a>'));
            } else {
                $(this).html($('<a>').attr('href', 'tel:' + $(this).text().replace(/-/g, '')).append(str + '</a>'));
            }
        });
    });
}